var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "order-list-items"
  }, [_vm._l((_vm.orders), function(item, index) {
    return _c('order-item', {
      key: item.order_id,
      attrs: {
        "order": item,
        "role": _vm.role
      }
    })
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.empty),
      expression: "empty"
    }],
    staticClass: "empty"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/empty.png"
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.tips))])])], 2)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@13.0.2@vue-loader/lib/template-compiler?{"id":"data-v-5a5e8bd5","hasScoped":true}!./~/_vue-loader@13.0.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/OrderList.vue
// module id = 241
// module chunks = 0